import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, EmptyState, StandaloneScreen } from 'components/app2';
import authService from 'utils/authService';

/**
 * 404 (rediseño jul-2026).
 *
 * Antes estaba en inglés ("Page Not Found · Go Back · Back to Home") dentro de
 * un producto en castellano, y "Home" mandaba siempre a la landing aunque la
 * persona tuviera sesión abierta. Ahora habla español y ofrece el destino que
 * corresponde: su pantalla de inicio si hay sesión, el sitio público si no.
 */
const NotFound = () => {
  const navigate = useNavigate();
  const autenticado = authService?.isAuthenticated?.();
  const inicio = autenticado ? (authService?.getUserRedirectRoute?.() || '/app') : '/';

  return (
    <StandaloneScreen maxWidth={560} title="Página no encontrada — PaySlip">
      <EmptyState
        icon="explore_off"
        size="lg"
        title="Esta página no existe"
        text="El enlace puede estar mal escrito o la pantalla pudo haber cambiado de lugar."
        action={(
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
            <Button variant="outline" icon="arrow_back" onClick={() => window.history?.back()}>
              Volver
            </Button>
            <Button icon={autenticado ? 'dashboard' : 'home'} onClick={() => navigate(inicio)}>
              {autenticado ? 'Ir a mi inicio' : 'Ir al sitio de PaySlip'}
            </Button>
          </div>
        )}
      />
    </StandaloneScreen>
  );
};

export default NotFound;
